import React from 'react';
import { Container, Paper, useTheme } from '@mui/material';
import { Loading } from './Loading';
import { getStyles, SheetRoot } from './styles';

interface BaseSheetProps {
  children: React.ReactNode;
  id?: string;
  maxWidth?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  widerPaper?: boolean;
}

export default function BaseSheet({
  children,
  id,
  maxWidth,
  loading,
  widerPaper,
}: BaseSheetProps) {
  const theme = useTheme();
  const paperStyles = getStyles(theme);

  return (
    <SheetRoot id={id}>
      <Container maxWidth={maxWidth || 'md'}>
        <Paper sx={widerPaper ? paperStyles.widePaper : paperStyles.paper}>
          {loading ? <Loading size={50} height='500px' /> : children}
        </Paper>
      </Container>
    </SheetRoot>
  );
}
